import { useId } from 'react';

// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './CircleLoader.module.css';

/**
 * Animated circle loader based on circle-loader.svg with a primary → secondary gradient.
 * @param {object} props
 * @param {boolean} [props.centered=false] - Center the loader in a full-width, full-height container
 * @param {string} [props.className] - Additional CSS classes for the SVG
 * @returns {JSX.Element}
 */
function CircleLoader({ centered = false, className = null }) {
  const gradientId = useId();

  const icon = (
    <svg
      className={cn([styles['circle-loader'], className])}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 38"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="var(--primary-500)" />
          <stop offset="100%" stopColor="var(--secondary-500)" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="2">
          <circle
            stroke="var(--secondary-400)"
            strokeOpacity="0.45"
            cx="18"
            cy="18"
            r="18"
          />
          <path stroke={`url(#${gradientId})`} d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );

  if (centered) {
    return (
      <div className={styles.centered} aria-busy="true" aria-live="polite">
        {icon}
      </div>
    );
  }

  return icon;
}

export default CircleLoader;
